import * as React from 'react'

const AppContext = React.createContext()

export const AppProvider = ({ children }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false)
  const [page, setPage] = React.useState('')
  const [universalMode, setUniversalMode] = React.useState('')
  const [value, setValue] = React.useState({
    top: 0,
    center: 0,
  })

  const TRA = (value) => {
    const { page, top, center } = value
    setValue({ top: top, center: center })
    setIsSubMenuOpen(true)
    setPage(page)
  }

  const DRM = (data) => {
    setUniversalMode(data)
  }
  return (
    <AppContext.Provider
      value={{
        value,
        setValue,
        isSubMenuOpen,
        setIsSubMenuOpen,
        universalMode,
        isMobileMenuOpen,
        setIsMobileMenuOpen,
        TRA,
        DRM,
        page,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const UseGlobalContext = () => {
  return React.useContext(AppContext)
}
